import { VehicleSideFunction } from '@/common/queries/selections/VehicleSide/VehicleSideQueryFunction';
import { queryOptions } from '@tanstack/react-query';

export const VehicleSideQueryOptions = ({
  enabled,
  vehicleType,
}: {
  enabled: boolean;
  vehicleType: number;
}) => {
  return queryOptions({
    queryKey: ['VehicleSide'],
    queryFn: () => VehicleSideFunction({ vehicleType }),
    enabled: enabled,
  });
};
